<template>
  <v-btn outlined tile color="primary" @click="$emit('click')">
    <v-icon left>mdi-plus</v-icon>

    <slot>
      Add New
    </slot>
  </v-btn>
</template>

<script>
export default {};
</script>

<style></style>
